import { useAppMutation } from '@/hooks/api';
import { API_ROUTES } from '@/constants/api-routes';
import mutationKeys from '@/constants/mutationKeys';

export const useDuplicateTemplateMutation = (templateId: string) => {
  return useAppMutation<{
    envelopeId: string;
    itemId: number;
  }>({
    routeName: API_ROUTES.DUPLICATE_TEMPLATE.replace(':templateId', templateId),
    mutationKey: [mutationKeys.TEMPLATE_GALLERY_DUPLICATE_TEMPLATE],
    method: 'POST' as const,
  });
};